import { Clause } from '~/api/def/endpoints/obligationsEndpoint';

export const ObligationCell = (props: { value: string; data: Clause }) => {
  if (!props.value) {
    return '-';
  }
  return (
    <>
      <strong className="pb-2 pt-1 inline-block">{props.value}</strong>
      <br />
      <span className="pb-2 inline-block">{props.data.summary}</span>
    </>
  );
};
